import { graphql } from "react-relay";

export const PUBLISHINGV2_FRAGMENT = graphql`
	fragment publishingFailedNotice_PublishingV2Fragment on PublishingV2 {
		status
		messages {
			message
			additionalMessage
		}
	}
`;
